import React, { useState} from "react";
import {
  Autocomplete,
  Button,
  Grid,
  Box,
  TextField
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import "./logdataform.css";
import AddNewCategoryDialog from "./AddNewCategoryDialog";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// Function to download a file and process the data
// This function fetches data from the server using the provided link

// Function to download a file and process the data. This function fetches data from the server using the provided link.
async function downloadFileAndProcessData(link,  token, onLogout, selectedCategory) {
  try {
      const response = await fetch(`${API_BASE_URL}/rawdata/download`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ fileLink: link , category: selectedCategory })
      });
      const data = await response.json();
      // console.log("Fetched data:", data);
      return data;
  } catch (error) {
      // console.error("Error fetching data:", error);
      if (error.response?.status === 401) {
        onLogout(); // Trigger logout on 401 Unauthorized
      }
  }
}

const LogDataForm = ({ triggerReload, auth, onLogout }) => {

const [loading, setLoading] = useState(false);
const [logForm, setLogForm] = useState({
  selectedCategory: "",
  link: "",
});
const [error, setError] = useState({
  selectedCategory: "",
  link: "",
});

// Validation function for the form inputs
const validate = () => {
  let valid = true;
  let newError = { link: "", selectedCategory: "" };
    // Check if link is empty or does not end with .txt
    if (!logForm.link || !logForm.link.endsWith(".txt")) {
      newError.link = "Please enter a valid input ending with .txt";
      valid = false;
    }
    // Check if category is selected
    if (!logForm.selectedCategory) {
      newError.selectedCategory = "Please select a category";
      valid = false
    }
    // If there are errors, set the error state
    setError(newError);
    return valid;
};

// Handlers for form inputs and button click

const handleSearchChange = (event) => {
  const value = event.target.value;
  setLogForm({ ...logForm, link: value }); //

  if (value.endsWith(".txt")) {
    // If valid, clear the error
    setError((prev) => ({ ...prev, link: "" }));
  } else if (!value) {
    // If empty, clear the error
    setError((prev) => ({ ...prev, link: "" }));
  }else {
    // If not valid, set the error
    setError((prev) => ({
      ...prev,
      link: "Please enter a valid input ending with .txt" }));
  }
};

const handlecategoryChange = (event, value) => {
  setLogForm({ ...logForm, selectedCategory: value ? value.label : "" });
  setError((prev) => ({ ...prev, selectedCategory: "" }));
};

// Function to handle the event when the button is clicked
const handleEvent = async () => {
  if (!validate()) return;
  setLoading(true);
  await downloadFileAndProcessData(logForm.link, auth.token, onLogout, logForm.selectedCategory);
  triggerReload();
  setLoading(false);
};

// Category options for the Autocomplete component
const [addNewCategoryDialogOpen, setaddNewCategoryDialogOpen] = React.useState(false);
const categories = [
    { label: "Drift" },
    { label: "Membrane_test" },
    { label: "Finger_test" },
    { label: "CorrugatA" },
    { label: "oil_a" },
    { label: "Tempbox" },
    { label: "__add_new__" }, // Special option for Add button
];

  return (
    <Box
      component="form"
      sx={{ "& .MuiTextField-root": { m: 1, width: "37ch" } }}
      noValidate
      autoComplete="off"
    >
      <Grid container size={{ xs: 12}} spacing={4}>
        <Grid size={{ xs: 1, md: 1 }}></Grid>

        <Grid size={{ xs: 10, md: 10 }} rowSpacing={4}>
          <div className="log_data_form">
            <Autocomplete
              required
              options={categories}

                          getOptionLabel={(option) =>
                          option.label === "__add_new__" ? "" : option.label
                          }
                          renderOption={(props, option) =>
                          option.label === "__add_new__" ? (
                          <li {...props} style={{ justifyContent: "center" }}>
                          <Button
                          startIcon={<AddIcon />}
                          size="small"
                          onClick={() => {
                            setaddNewCategoryDialogOpen(true)
                           }}
                        >
                        Add New Category
                        </Button>
                        </li>
                        ) : (
                        <li {...props}>{option.label}</li>
                      )
                    }
              renderInput={(params) => (
                  <TextField {...params}
                  label={error.selectedCategory ? error.selectedCategory : "categories"}
                  size="small"
                  required
                  error={Boolean(error.selectedCategory)}
                  />
                  )}
              onChange={handlecategoryChange}
              clearOnEscape
            />
            <TextField
              required
              id="outlined-required"
              size="small"
              label={error.link ? error.link : "Required"}
              error={Boolean(error.link)}
              onChange={handleSearchChange}

            />
            <Button
            variant="contained"
            startIcon={<AddIcon />}
            size="small"
            sx={{ marginLeft: "10px" }}
            onClick={handleEvent}
            loading={loading}
            loadingIndicator="Loading…"
            >
            Add Data
            </Button>
          </div>
        </Grid>

        <Grid size={{ xs: 1, md: 1 }}></Grid>
      </Grid>
      <AddNewCategoryDialog open={addNewCategoryDialogOpen} onclose={() => setaddNewCategoryDialogOpen(false)}/>
    </Box>
  );
};

export default LogDataForm;